import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/VideoPlayerMobile.css';

const MobilCard = ({ type, src, text, button, link, openLoginPopup }) => {
    const navigate = useNavigate();
    const videoRef = useRef(null);

    useEffect(() => {
        if (type === 'video' && videoRef.current) {
            videoRef.current.play().catch(() => { });
        }
    }, [type]);

    const handleClick = async () => {
        if (button === 'Hemen Başvur') {
            const token = localStorage.getItem('token');
            if (!token) {
                openLoginPopup ? openLoginPopup() : navigate('/login');
                return;
            }

            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/GetUserIdByToken`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 200) {
                    navigate(link);
                } else {
                    openLoginPopup ? openLoginPopup() : navigate('/login');
                }
            } catch {
                openLoginPopup ? openLoginPopup() : navigate('/login');
            }
        } else {
            navigate(link);
        }
    };

    return (
        <div className="mobil-card">
            {type === 'image' ? (
                <img src={src} alt="card" className="mobil-card-image" />
            ) : (
                <video
                    ref={videoRef}
                    src={src}
                    className="mobil-card-video"
                    muted
                    loop
                    playsInline
                    autoPlay
                    disablePictureInPicture
                    controlsList="nodownload nofullscreen noplaybackrate"
                />
            )}

            <div className="mobil-card-content">
                <p>{text}</p>
                <button onClick={handleClick}>{button}</button>
            </div>
        </div>
    );
};

const VideoPlayerMobil = ({ openLoginPopup }) => {
    return (
        <div className="mobil-home-wrapper">
            <MobilCard
                type="image"
                src="/images/1.jpeg"
                text="Fulla Moda Ailesine Hoş Geldin! Bizleri Daha Yakından Tanımak İstermisin?"
                button="Hakkımızda"
                link="/about"
            />
            <MobilCard
                type="video"
                src="/videos/6.mp4" 
                text="CV’ni tamamla, bu ekibin bir parçası ol fırsatlar seni bekliyor!!"
                button="Hemen Başvur"
                link="/ozgecmisim"
                openLoginPopup={openLoginPopup}
            />
            <MobilCard
                type="video"
                src="/videos/5.mp4"
                text="Fulla Moda’da seni bekleyen kariyer yolculuğunu şimdi keşfet."
                button="Kariyer Fırsatlarını Gör"
                link="/joblist"
            />
        </div>
    );
};

export default VideoPlayerMobil;
